<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <div
      id="tabulator"
      ref="tableRef"
      class="mt-5 table-report table-report--tabulator"
    ></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import langs from '@/locale.tabulator'
import newsApi from '@/services/advertisement/advertisement.api'

export default defineComponent({
  data() {
    return {
      tabulator: null
    }
  },
  methods: {
    showDetail(e, cell) {
      this.$router.push({
        name: 'superadmin-tools-advertisement-detail',
        params: { uuid: cell.getData().uuid }
      })
    },
    showEdit(e, cell) {
      this.$router.push({
        name: 'superadmin-tools-advertisement-edit',
        params: { uuid: cell.getData().uuid }
      })
    },
    formatDate(date) {
      const d = new Date(date)
      return (
        d.toISOString().replace(/^(\d+)-(\d+)-(\d+).*$/, '$3.$2.$1') +
        ' ' +
        d.toLocaleTimeString().replace(/^(\d+):(\d+):\d+$/, '$1:$2')
      )
    },
    activeFormatter(cell) {
      if (!cell.getData().active) {
        return (
          '<div class="flex lg:justify-center items-center">' +
          this.$t('common.notActiveShe') +
          '</div>'
        )
      }
      if (cell.getData().visibleFrom === null && cell.getData().visibleTo === null) {
        return (
          '<div class="flex lg:justify-center items-center">' +
          this.$t('common.activeShe') +
          '</div>'
        )
      }
      if (cell.getData().visibleFrom === null && cell.getData().visibleTo !== null) {
        return (
          '<div class="flex lg:justify-center items-center">' +
          this.$t('common.activeShe') +
          ' - ' +
          this.formatDate(cell.getData().visibleTo) +
          ' > ' +
          '</div>'
        )
      }
      if (cell.getData().visibleFrom !== null && cell.getData().visibleTo === null) {
        return (
          '<div class="flex lg:justify-center items-center">' +
          this.$t('common.activeShe') +
          ' - ' +
          this.formatDate(cell.getData().visibleFrom) +
          ' < ' +
          '</div>'
        )
      }
      return (
        '<div class="flex lg:justify-center items-center">' +
        this.$t('common.activeShe') +
        ' - ' +
        this.formatDate(cell.getData().visibleFrom) +
        ' - ' +
        this.formatDate(cell.getData().visibleTo) +
        '</div>'
      )
    },
    detailFormatter(cell) {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-info detail-action">' +
        this.$t('common.detail') +
        '</button></div>'
      )
    },
    editFormatter(cell) {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-primary detail-action">' +
        this.$t('common.edit') +
        '</button></div>'
      )
    }
  },
  mounted() {
    this.tabulator = new Tabulator(this.$refs.tableRef, {
      locale: 'sk',
      langs: langs,
      ajaxURL: '#',
      ajaxConfig: 'POST',
      ajaxRequestFunc: function (url, config, params) {
        console.log(url)
        console.log(params)
        console.log(config)
        return newsApi.getList(params.page, params.size)
      },
      ajaxResponse: function (url, params, response) {
        const pagination = response.data.pagination
        return {
          data: response.data.data,
          last_page: Math.ceil(pagination.filtered / pagination.perPage)
        }
      },
      printAsHtml: true,
      printStyled: true,
      pagination: true,
      paginationMode: 'remote',
      paginationSize: 10,
      paginationSizeSelector: [10, 20, 30, 40],
      sortMode: 'remote',
      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',
      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          minWidth: 30,
          hozAlign: 'center',
          resizable: false,
          headerSort: false
        },

        // For HTML table
        {
          title: this.$t('common.title'),
          minWidth: 200,
          responsive: 0,
          field: 'name',
          vertAlign: 'middle',
          headerSort: false,
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">${
                  cell.getData().title
                }</div>
              </div>`
          }
        },
        {
          title: this.$t('common.description'),
          minWidth: 200,
          responsive: 0,
          headerSort: false,
          field: 'name',
          vertAlign: 'middle',
          headerHozAlign: 'left',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">${
                  cell.getData().perex.sk_SK
                }</div>
              </div>`
          }
        },
        {
          title: this.$t('common.active'),
          minWidth: 200,
          responsive: 0,
          headerSort: false,
          field: 'name',
          vertAlign: 'middle',
          headerHozAlign: 'left',
          print: false,
          download: false,
          formatter: this.activeFormatter
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionDetail',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.detailFormatter,
          cellClick: this.showDetail
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionEdit',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.editFormatter,
          cellClick: this.showEdit
        }
      ]
    })
  }
})
</script>
